import { clsx } from 'clsx'
import { Space } from 'component/Space'
import { Vertical } from 'component/Vertical'
import { useLatestCallback } from 'hook/useLatestCallback'
import { observer } from 'mobx-react-lite'
import Body1Svg from 'page/ProfileScreen/BasicSelfiesPanel/asset/body/body-1.svg'
import Body2Svg from 'page/ProfileScreen/BasicSelfiesPanel/asset/body/body-2.svg'
import Body3Svg from 'page/ProfileScreen/BasicSelfiesPanel/asset/body/body-3.svg'
import Body4Svg from 'page/ProfileScreen/BasicSelfiesPanel/asset/body/body-4.svg'
import Body5Svg from 'page/ProfileScreen/BasicSelfiesPanel/asset/body/body-5.svg'
import css from 'page/ProfileScreen/BasicSelfiesPanel/body/BodySelect.module.scss'
import { store } from 'store/store'

export const BodySelect = observer(() => {
  const basic = store.profile.basic
  const body1 = basic.body === 1 && css.selected
  const body2 = basic.body === 2 && css.selected
  const body3 = basic.body === 3 && css.selected
  const body4 = basic.body === 4 && css.selected
  const body5 = basic.body === 5 && css.selected

  const onBody1 = useLatestCallback(() => basic.body = 1)
  const onBody2 = useLatestCallback(() => basic.body = 2)
  const onBody3 = useLatestCallback(() => basic.body = 3)
  const onBody4 = useLatestCallback(() => basic.body = 4)
  const onBody5 = useLatestCallback(() => basic.body = 5)

  return (
    <Space gap={12}>
      <Vertical className={clsx(css.item, body1)} onClick={onBody1}>
        <Body1Svg />
      </Vertical>
      <Vertical className={clsx(css.item, body2)} onClick={onBody2}>
        <Body2Svg />
      </Vertical>
      <Vertical className={clsx(css.item, body3)} onClick={onBody3}>
        <Body3Svg />
      </Vertical>
      <Vertical className={clsx(css.item, body4)} onClick={onBody4}>
        <Body4Svg />
      </Vertical>
      <Vertical className={clsx(css.item, body5)} onClick={onBody5}>
        <Body5Svg />
      </Vertical>
    </Space>
  )
})
